import Vue from 'vue'
import mdiVue from 'mdi-vue'
import * as mdijs from '@mdi/js'

Vue.use(mdiVue, {
    icons: mdijs
})